<template>
  <div class="">
    解决方案
  </div>
</template>

<script>
export default {
  name: ''
}
</script>

<style lang="scss" scoped>

</style>
